import {Record} from 'immutable';
import {ReduceStore} from 'flux/utils';
import ActionTypes from '../ActionTypes';
import AppDispatcher from '../AppDispatcher';

const State = new Record({
  pagos: [],
  selecionada: null,
  cpfClientePedidos: '',
  idClientePedidos: '',
  showQrPreviewPedidos: false,
  confirm: false,
  onConfirm() {},
  onCancel: null,
  title: '',
  text: '',
});

class LojaPedidosStore extends ReduceStore {
    constructor() {
        super(AppDispatcher);
    }

    getInitialState() {
        return new State();
    }

    reduce(state, action) {
        switch (action.type) {
            case ActionTypes.UPDATE_TOKEN_FAILED:
            case ActionTypes.LOGOUT:
                return state.clear();

            case ActionTypes.LIST_PAID_ORDERS_FINISH:
                let result = state.set('pagos', action.itens);
                if (state.selecionada) {
                    const selecionada = result.pagos.find(o => o.id == state.selecionada.id);
                    result = result
                      .set('selecionada', selecionada);
                }
                return result;

            case ActionTypes.SELECT_PAID_ORDER:
                const selecionada = state.pagos.find(o => o.id == action.orderId);
                return state
                    .set('selecionada', selecionada)
                    .set('cpfClientePedidos', selecionada.cpf)
                    .set('showQrPreviewPedidos', false)
                    .set('idClientePedidos', '');

            case ActionTypes.UPDATE_TEXT:
                if (action.field === 'cpfClientePedidos')
                    return state.set('cpfClientePedidos', action.value);
                if (action.field === 'idClientePedidos')
                    return state.set('idClientePedidos', action.value);
                if (action.field === 'showQrPreviewPedidos')
                    return state.set('showQrPreviewPedidos', action.value);

            case ActionTypes.SHOW_SWAL:
                return state
                    .set('confirm', true)
                    .set('title', action.title)
                    .set('text', action.text)
                    .set('onConfirm', action.onConfirm)
                    .set('onCancel', action.onCancel);

            case ActionTypes.CLOSE_SWAL:
                return state
                    .set('confirm', false)
                    .set('title', '')
                    .set('text', '')
                    .set('onConfirm', () => {})
                    .set('onCancel', null);

            default:
                return state;
        }
    }
}

export default new LojaPedidosStore();



// WEBPACK FOOTER //
// src/stores/LojaPedidosStore.js